import React from "react"
import { makeStyles } from "@material-ui/core/styles"

const BlockquoteStyle = theme => ({
  root: {
    backgroundColor: "white",
    borderLeft: theme.spacing(2) + "px solid " + theme.palette.primary.light,
    padding: theme.spacing(2) + "px ",
    marginBottom: theme.spacing(2),
    "&>p": {
      fontSize: theme.typography.h5.fontSize,
      fontWeight: theme.typography.h5.fontWeight,
      lineHeight: theme.typography.h5.lineHeight,
      color: theme.palette.text.secondary,
    },
  },
})

const useStyles = makeStyles(BlockquoteStyle)
export default function Blockquote({ children }) {
  const classes = useStyles()
  return <div className={classes.root}>{children}</div>
}
